"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7323],{

/***/ 97323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ features_about; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/HomePageLayout/index.tsx + 10 modules
var HomePageLayout = __webpack_require__(22647);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
;// CONCATENATED MODULE: ./src/features/about/styled.tsx
/* eslint-disable import/prefer-default-export */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 30px;\n  margin: 50px auto;\n  height: 100%;\n  \n  @media ",
        " {\n    padding: 0;\n    max-width: 1300px;\n    width: calc(100% - 150px);\n    margin: 150px auto;\n  }\n}"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 100px 0;\n\n  img {\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n\n  @media ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.5;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n\n  @media ",
        " {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: 1fr;\n    grid-column-gap: 25px;\n    grid-row-gap: 0px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 10px;\n  margin-bottom: 25px;\n\n  .address {\n    margin: 22px;\n    background: url(",
        "/images/pin.png) no-repeat top left;\n    padding-left: 68px;\n  }\n\n  h5 {\n    font-size: 16px;\n\n    @media ",
        " {\n      font-size: 24px;\n      margin-bottom: 10px;\n    }\n  }\n\n  p {\n    font-size: 14px;\n\n    @media ",
        " {\n      font-size: 18px;\n      margin-bottom: 20px;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 40px;\n  margin-bottom: ",
        ";\n\n  @media ",
        " {\n    font-size: 26px;\n  }\n\n  @media ",
        " {\n    font-size: 40px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 30px;\n  margin-bottom: 20px;\n\n  @media ",
        " {\n    font-size: 20px;\n  }\n\n  @media ",
        " {\n    font-size: 30px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
var Container = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-e1ee9f49-0"
})(_templateObject(), ui/* device.tablet */.Uh.tablet);
var AboutContainer = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-e1ee9f49-1"
})(_templateObject1());
var AboutContainerInner = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-e1ee9f49-2"
})(_templateObject2(), ui/* device.laptop */.Uh.laptop);
var Paragraph = (0,styled_components_browser_esm["default"])(Text).attrs({
    as: "p",
    size: "18px",
    mt: "24px;",
    align: "justify"
}).withConfig({
    componentId: "sc-e1ee9f49-3"
})(_templateObject3());
var ContactContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e1ee9f49-4"
})(_templateObject4(), ui/* device.laptop */.Uh.laptop);
var ContactBox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e1ee9f49-5"
})(_templateObject5(), ui/* color.gainsboro */.$_.gainsboro, app/* assetPrefix */.Vc, ui/* device.tablet */.Uh.tablet, ui/* device.tablet */.Uh.tablet);
var Title = (0,styled_components_browser_esm["default"])(Text).attrs({
    as: "h3",
    family: "bold"
}).withConfig({
    componentId: "sc-e1ee9f49-6"
})(_templateObject6(), function(props) {
    return props.mb ? props.mb : "20px";
}, ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
var MiniTitle = (0,styled_components_browser_esm["default"])(Text).attrs({
    as: "h3",
    family: "bold"
}).withConfig({
    componentId: "sc-e1ee9f49-7"
})(_templateObject7(), ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);

;// CONCATENATED MODULE: ./src/features/about/constants.ts
var timelines = [
    {
        year: 2000,
        desc: "Perubahan Management dan Kepemilikan"
    },
    {
        year: 2007,
        desc: "Menggunakan ‘Remote Trading’"
    },
    {
        year: 2009,
        desc: "Berpartisipasi dalam Transaksi Negosiasi PT Adaro Energy senilai Rp15,73 Triliun"
    },
    {
        year: 2021,
        desc: "Terdaftar di KSEI dan IDX sebagai sekuritas yang dapat melakukan pembukaan rekening efek secara digital "
    },
    {
        year: 2021,
        desc: "Perubahan Manajemen & Kepemilikian dari PT Mahakarya Artha Sekuritas menjadi PT Stockbit Sekuritas Digital "
    }, 
];
var managements = [
    {
        name: "Bacelius Ruru",
        position: "Komisaris Utama & Independen",
        desc: "Menjabat resmi sebagai Komisaris Utama dan Independen PT Stockbit Sekuritas Digital sejak tahun 2021, beliau meniti karir pada Departemen Keuangan dan menduduki sejumlah jabatan penting di lingkungan Departemen Keuangan dan Kementerian BUMN, antara lain Ketua Badan Pengawas Pasar Modal ‘Bapepam’(1993-1995) selanjutnya, menjadi Komisaris Utama PT Bursa Efek Indonesia periode 2001-2008."
    },
    {
        name: "Wellson Lo",
        position: "Komisaris",
        desc: "Menjabat resmi sebagai Komisaris PT. Stockbit Sekuritas Digital sejak tahun 2022, beliau merupakan Lulusan Bachelor of Accounting and Finance dari University of Melbourne dan Master in Finance dari Monash University dimana memiliki pengalaman\xa0 selama 4 tahun dalam bidang audit, analis saham dan financial controller di Singapura dan Jakarta."
    },
    {
        name: "Megawati Andrew Soewardi",
        position: "Direktur Utama",
        desc: "Menjabat resmi sebagai Direktur Utama PT. Stockbit Sekuritas Digital, beliau mengawali karirnya di Industri Pasar Modal sejak tahun 1997. Pada tahun 2012, beliau diangkat menjadi Direktur Utama PT. Mahakarya Artha Securities hingga perusahaan berganti nama sekarang menjadi PT Stockbit Sekuritas Digital."
    },
    {
        name: "Jason Terence Halim",
        position: "Direktur",
        desc: "Menjabat resmi sebagai Direktur PT. Stockbit Sekuritas Digital, beliau mengawali karirnya di Industri Pasar Modal sejak tahun 2007. Pada tahun 2011, beliau diangkat menjadi Direktur PT. Mahakarya Artha Securities hingga perusahaan berganti nama menjadi PT Stockbit Sekuritas Digital."
    },
    {
        name: "Jana Lukito",
        position: "Direktur",
        desc: "Menjabat resmi sebagai Direktur PT. Stockbit Sekuritas Digital, beliau memiliki latar belakang keuangan dan mengawali karirnya di Industri Pasar Modal sejak tahun 2001. Beliau juga diangkat menjadi Direktur PT. Mahakarya Artha Securities sejak tahun 2001 hingga sekarang dimana perusahaan berganti nama menjadi PT Stockbit Sekuritas Digital."
    }, 
];
var licenseHolder = [
    {
        name: "Dewan Komisaris",
        position: "Pemegang Lisensi  WPPE OJK",
        count: 1
    },
    {
        name: "Direksi",
        position: "Pemegang Lisensi  WPPE OJK",
        count: 3
    },
    {
        name: "Karyawan",
        position: "Pemegang Lisensi  WPPE OJK",
        count: 18
    },
    {
        name: "Karyawan",
        position: "Pemegang Lisensi  WPEE OJK",
        count: 1
    }
];

;// CONCATENATED MODULE: ./src/features/about/about/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 40px;\n  border-radius: 12px;\n  box-sizing: border-box;\n  border: 1px solid ",
        ";\n  margin-bottom: 80px;\n\n  @media ",
        " {\n    margin-bottom: 40px;\n  }\n\n  @media ",
        " {\n    width: 42%;\n    margin-right: 3%;\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    width: 50%;\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: url(",
        "/images/dot.svg) no-repeat;\n  padding-left: 45px;\n  min-height: 50px;\n  margin-bottom: 30px;\n  background-position: 0 20px;\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  margin-top: 3px;\n  @media ",
        " {\n    font-size: 19px;\n  }\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var styled_Text = ui/* Common.Text */.Gn.Text;
var TimelineBox = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-f65cb848-0"
})(styled_templateObject(), ui/* color.downgray */.$_.downgray, ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
var CompanyInfo = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-f65cb848-1"
})(styled_templateObject1(), ui/* device.laptop */.Uh.laptop);
var Timeline = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-f65cb848-2"
})(styled_templateObject2(), app/* assetPrefix */.Vc);
var TimelineTitle = (0,styled_components_browser_esm["default"])(styled_Text).attrs({
    as: "p",
    family: "bold"
}).withConfig({
    componentId: "sc-f65cb848-3"
})(styled_templateObject3(), ui/* device.tablet */.Uh.tablet);

;// CONCATENATED MODULE: ./src/features/about/about/index.tsx





var about_Text = ui/* Common.Text */.Gn.Text;
var AboutUs = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContainerInner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineBox, {
                    children: timelines.map(function(timeline) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Timeline, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(about_Text, {
                                    as: "p",
                                    size: "16px",
                                    children: timeline.year
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineTitle, {
                                    children: timeline.desc
                                })
                            ]
                        }, timeline.year);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyInfo, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: "Informasi Perusahaan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                            children: "Berdiri sejak tahun 1990 dengan nama PT Mahakarya Artha Sekuritas dan terdaftar di OJK dengan nomor izin KEP-132/PM/1992, PT Mahakarya Artha Sekuritas terus berkomitmen dalam meningkatkan jumlah investor di Indonesia untuk membantu perekonomian nasional. Pada Desember 2021, PT Mahakarya Artha Sekuritas telah resmi diakuisisi dan berganti nama menjadi PT Stockbit Sekuritas Digital."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                            children: "Sebagai perusahaan efek yang telah memiliki pengalaman, PT Stockbit Sekuritas Digital berkomitmen untuk terus melakukan inovasi dan memberikan layanan serta pengalaman investasi yang mudah, aman dan terpercaya bagi investor melalui teknologi kelas dunia untuk dapat memfasilitasi masyarakat dalam berinvestasi secara mudah di pasar modal Indonesia melalui layanan perdagangan saham online yang modern. Melalui aplikasi investasi sosial Stockbit investor dapat berdiskusi sekaligus melakukan transaksi saham secara daring. Pembukaan akun rekening sekuritas juga dapat dilakukan melalui aplikasi Stockbit yang dapat diunduh melalui Playstore dan Appstore."
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var about = (AboutUs);

;// CONCATENATED MODULE: ./src/features/about/vision/styled.ts
/* eslint-disable import/prefer-default-export */ 
function vision_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column-reverse;\n  margin-top: 32px;\n\n  @media ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    vision_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function vision_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    width: calc(100% - 250px);\n    // margin-right: 80px;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    padding: 16px 80px 16px 16px;\n    border: 1px solid #EDEDED;\n    border-radius: 12px;\n  }\n\n  @media ",
        " {\n    width: 100%;\n  }\n"
    ]);
    vision_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function vision_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    h3{\n      text-align: center;\n    }\n  }\n\n  @media ",
        " {\n    flex: 1;\n     \n    h3 {\n      text-align: left;\n    }\n  }\n\n  ul {\n    padding-left: 30px;\n    padding-top: 16px;\n  }\n"
    ]);
    vision_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function vision_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 200px;\n  margin-bottom: 40px;\n\n  @media ",
        " {\n    width: 250px;\n    margin-bottom: 0;\n  }\n\n  @media ",
        " {\n    width: auto;\n  }\n  \n"
    ]);
    vision_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    display: flex;\n    justify-content: center;\n  }\n\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var VisionContainer = (0,styled_components_browser_esm["default"])(AboutContainerInner).withConfig({
    componentId: "sc-d2fbdb1b-0"
})(vision_styled_templateObject(), ui/* device.tablet */.Uh.tablet);
var VisionMissionBox = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-d2fbdb1b-1"
})(vision_styled_templateObject1(), ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
var VisMisBox = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-d2fbdb1b-2"
})(vision_styled_templateObject2(), ui/* device.mobileS */.Uh.mobileS, ui/* device.tablet */.Uh.tablet);
var VisionImage = (0,styled_components_browser_esm["default"])(Image/* default */.Z).withConfig({
    componentId: "sc-d2fbdb1b-3"
})(vision_styled_templateObject3(), ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
var VisionImageContainer = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-d2fbdb1b-4"
})(styled_templateObject4(), ui/* device.mobileS */.Uh.mobileS, ui/* device.tablet */.Uh.tablet);

;// CONCATENATED MODULE: ./src/features/about/vision/index.tsx



var Vision = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                align: "center",
                mb: "50px",
                children: "Visi & Misi Perusahaan"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionContainer, {
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VisionMissionBox, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionImageContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionImage, {
                                src: "/images/vision.svg"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(VisMisBox, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniTitle, {
                                    children: "Visi Perusahaan"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                    children: "Visi kami adalah menjadi penasihat, perantara, dan rekanan yang terpercaya untuk membantu nasabah dalam menentukan strategi finansial di pasar modal indonesia. Stockbit Sekuritas Digital berkomitmen untuk memberikan layanan yang handal dan konsisten untuk kepentingan nasabah."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VisionMissionBox, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionImageContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionImage, {
                                src: "/images/mission.svg"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(VisMisBox, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniTitle, {
                                    children: "Misi Perusahaan"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph, {
                                    children: [
                                        "Misi kami adalah untuk menyediakan sarana investasi pasar modal yang mudah, aman dan nyaman untuk pemula. Selain itu, Misi penting kami juga terbagi dalam 3 hal utama, yaitu:",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "Meningkatkan literasi keuangan dengan meningkatkan edukasi dan kesadaran berinvestasi"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "Berkontribusi dalam suatu sistem pasar modal yang bekerja dengan baik dan inklusif"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "Berkontribusi untuk memperdalam pasar modal sehingga memperkuat platform penggalangan dana untuk perusahaan Indonesia"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var vision = (Vision);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/features/about/management/styled.tsx
/* eslint-disable import/prefer-default-export */ 
function management_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    width: calc(100% - 400px);\n    margin-right: 40px;\n  }\n"
    ]);
    management_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function management_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    management_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function management_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: auto auto;\n  grid-column-gap: 28px;\n  grid-row-gap: 28px;\n  flex-direction: column;\n\n  &:last-child {\n    > div:first-child {\n      grid-column: 1 / span 2;\n      margin-bottom: 0;\n      margin-top: 28px;\n    }\n  }\n\n  @media ",
        " {\n    flex-direction: column;\n    display: flex;\n  }\n\n  @media ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    management_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function management_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px;\n  border-radius: 12px;\n  box-sizing: border-box;\n  border: ",
        ";\n  margin: 14px 0px;\n  min-height: 100%;\n\n  /** &:not(.position-3) {\n    width: calc(50% - 14px);\n    float: left;\n  }\n\n  &.position-1,\n  &.position-4 {\n    margin-right: 14px;\n  }\n\n  &.position-2,\n  &.position-5 {\n    margin-left: 14px;\n  } **/\n\n  @media ",
        " {\n    padding: 40px;\n    min-height: 1px;\n  }\n\n  @media ",
        " {\n    width: 33%;\n    margin: 20px 10px;\n    min-height: 1px;\n  }\n\n  &:hover,\n  &:focus,\n  &:active {\n    border: 2px solid #00AB6B;\n  }\n"
    ]);
    management_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function management_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-body {\n    padding: 40px;\n    border-radius: 12px;\n  }\n\n  .ant-modal-close{\n    display: none;\n    visibility: hidden;\n    opacity: 0;\n  }\n"
    ]);
    management_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var styled_Flex = ui/* Common.Flex */.Gn.Flex, ModalAntd = ui/* Common.Modal */.Gn.Modal;
var VisionBox = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-73546a7c-0"
})(management_styled_templateObject(), ui/* device.tablet */.Uh.tablet);
var styled_VisionImage = (0,styled_components_browser_esm["default"])(Image/* default */.Z).withConfig({
    componentId: "sc-73546a7c-1"
})(management_styled_templateObject1(), ui/* device.tablet */.Uh.tablet);
var ManagementContainer = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    align: "flex-start",
    justify: "center"
}).withConfig({
    componentId: "sc-73546a7c-2"
})(management_styled_templateObject2(), ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
var Card = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-73546a7c-3"
})(management_styled_templateObject3(), function(props) {
    return props.active ? "2px solid #00AB6B" : "1px solid #ededed";
}, ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
var Modal = (0,styled_components_browser_esm["default"])(ModalAntd).withConfig({
    componentId: "sc-73546a7c-4"
})(management_styled_templateObject4());

;// CONCATENATED MODULE: ./src/features/about/management/index.tsx








var management_Text = ui/* Common.Text */.Gn.Text;
var Person = function(param) {
    var name = param.name, position = param.position, desc = param.desc, showDesc = param.showDesc;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(management_Text, {
                as: "p",
                family: "bold",
                size: showDesc ? "30px" : "22px",
                mt: "4px",
                mb: "4px",
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(management_Text, {
                as: "p",
                family: "bold",
                size: showDesc ? "20px" : "16px",
                mt: "4px",
                color: ui/* color.suvaGrey */.$_.suvaGrey,
                children: position
            }),
            showDesc && /*#__PURE__*/ (0,jsx_runtime.jsx)(management_Text, {
                as: "p",
                size: "18px",
                mt: "24px",
                align: "justify",
                children: desc
            })
        ]
    });
};
var Management = function() {
    var defaultModalData = {
        name: "",
        position: "",
        desc: ""
    };
    var ref = (0,react.useState)(false), showModalManagement = ref[0], setShowModalManagement = ref[1];
    var ref1 = (0,react.useState)(defaultModalData), modalData = ref1[0], setModalData = ref1[1];
    var showModal = function(management) {
        toggleModal(true);
        setModalData(management);
    };
    var toggleModal = function(params) {
        setShowModalManagement(params);
    };
    var closeModal = function() {
        toggleModal(false);
        setModalData(defaultModalData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                align: "center",
                mb: "60px",
                children: "Manajemen"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagementContainer, {
                children: managements.slice(0, 2).map(function(management) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                        active: management.name === modalData.name,
                        onClick: function() {
                            return showModal(management);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Person, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, management), {
                            showDesc: false
                        }), management.name)
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagementContainer, {
                children: managements.slice(2, 6).map(function(management) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                        active: management.name === modalData.name,
                        onClick: function() {
                            return showModal(management);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Person, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, management), {
                            showDesc: false
                        }), management.name)
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                visible: showModalManagement,
                onCancel: closeModal,
                centered: true,
                width: 700,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Person, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalData), {
                    showDesc: true
                }))
            })
        ]
    });
};
/* harmony default export */ var management = (Management);

// EXTERNAL MODULE: ./src/constants/company.js
var company = __webpack_require__(81422);
// EXTERNAL MODULE: ./src/features/static/GoogleMap.tsx
var GoogleMap = __webpack_require__(54690);
;// CONCATENATED MODULE: ./src/features/about/contact/styled.ts

function contact_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n\n  @media ",
        " {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: 1fr;\n    grid-column-gap: 25px;\n    grid-row-gap: 0px;\n  }\n"
    ]);
    contact_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function contact_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 10px;\n  margin-bottom: 25px;\n\n  &.map {\n    height: 320px;\n\n    @media ",
        " {\n      height: 608px;\n    }\n\n    @media ",
        " {\n      height: auto;\n    }\n  }\n"
    ]);
    contact_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function contact_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: url(",
        "/",
        ") no-repeat top left;\n    padding: 0 20px 20px 75px;\n    background-position: 20px 0;\n    background-size: 32px 32px;\n    word-break: break-word;\n\n    @media ",
        " {\n      padding: 0 30px 30px 98px;\n      background-position: 30px 0;\n      background-size: 48px 48px;\n      word-break: normal;\n    }\n\n    &:first-child {\n      padding-top: 20px;\n      background-position: 20px 20px;\n      @media ",
        " {\n        padding-top: 30px;\n        background-position: 30px 30px;\n      }\n    }\n\n    p {\n      font-size: 19px;\n      margin-top: 0;\n      margin-bottom: 0;\n    }\n\n    h5 {\n      font-size: 19px;\n    }\n"
    ]);
    contact_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var styled_ContactContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a94424ea-0"
})(contact_styled_templateObject(), ui/* device.laptop */.Uh.laptop);
var styled_ContactBox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a94424ea-1"
})(contact_styled_templateObject1(), ui/* color.gainsboro */.$_.gainsboro, ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
var ContactItem = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a94424ea-2"
})(contact_styled_templateObject2(), app/* assetPrefix */.Vc, function(props) {
    return props.icon;
}, ui/* device.tablet */.Uh.tablet, ui/* device.tablet */.Uh.tablet);

;// CONCATENATED MODULE: ./src/features/about/contact/index.tsx






var contact_Text = ui/* Common.Text */.Gn.Text;
var Contact = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                align: "center",
                mb: "60px",
                children: "Hubungi Kami"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_ContactContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_ContactBox, {
                        className: "map",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleMap/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_ContactBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactItem, {
                                icon: "images/location.svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_Text, {
                                        as: "h5",
                                        family: "bold",
                                        mb: "15px",
                                        size: "19px",
                                        children: company/* companyName */.ub
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                        children: company/* address */.Lk
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactItem, {
                                icon: "images/email.svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_Text, {
                                        as: "h5",
                                        family: "bold",
                                        mb: "15px",
                                        size: "19px",
                                        children: "Kontak Utama"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph, {
                                        children: [
                                            "Untuk segala pertanyaan dan masalah, kamu dapat mengunjungi pusat bantuan kami. Jika kamu membutuhkan bantuan lebih jauh, kamu dapat mengirimkan email ke",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_Text, {
                                                as: "b",
                                                family: "bold",
                                                size: "19px",
                                                children: company/* supportEmail */.sJ
                                            }),
                                            "."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactItem, {
                                icon: "images/phone.svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_Text, {
                                        as: "h5",
                                        family: "bold",
                                        mb: "15px",
                                        size: "19px",
                                        children: "Telepon"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                        children: company/* phone */.m7
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var contact = (Contact);

;// CONCATENATED MODULE: ./src/features/about/LicenseHolder/styled.tsx

function LicenseHolder_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-wrap: wrap;\n  justify-content: space-around;\n  margin-top: 60px;\n\n  @media ",
        " {\n    margin-bottom: 160px;\n  }\n"
    ]);
    LicenseHolder_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LicenseHolder_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 47%;\n  border: 1px solid #EDEDED;\n  padding: 40px 50px;\n  border-radius: 12px;\n  margin-bottom: 40px;\n  \n  @media ",
        " {\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n  }\n\n  @media ",
        " {\n    width: 47%;\n  }\n"
    ]);
    LicenseHolder_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LicenseHolder_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  align-items: center;\n  height: 93px;\n  width: 93px;\n  border: 2px solid #EDEDED;\n  border-radius: 50%;\n  margin-right: 40px;\n\n  p{\n    color: #00BF71;\n  }\n\n  @media ",
        " {\n    height: 70px;\n  }\n  \n  @media ",
        " {\n    height: 93px;\n  }\n"
    ]);
    LicenseHolder_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LicenseHolder_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: center;\n  flex-wrap: wrap\n  h5{\n    color: #949494;\n  }\n  \n  @media ",
        " {\n    height: auto;\n\n    h3{\n      font-size: 26px;\n    }\n\n    h5{\n      font-size: 16px;\n    }\n  }\n\n  @media ",
        " {\n    height: 93px;\n  }\n"
    ]);
    LicenseHolder_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var LicenseHolder_styled_Flex = ui/* Common.Flex */.Gn.Flex;
var LicenseHolderContainer = (0,styled_components_browser_esm["default"])(LicenseHolder_styled_Flex).withConfig({
    componentId: "sc-4587003c-0"
})(LicenseHolder_styled_templateObject(), ui/* device.laptop */.Uh.laptop);
var LicenseHolderBox = (0,styled_components_browser_esm["default"])(LicenseHolder_styled_Flex).withConfig({
    componentId: "sc-4587003c-1"
})(LicenseHolder_styled_templateObject1(), ui/* device.mobileS */.Uh.mobileS, ui/* device.laptop */.Uh.laptop);
var LicenseCount = (0,styled_components_browser_esm["default"])(LicenseHolder_styled_Flex).withConfig({
    componentId: "sc-4587003c-2"
})(LicenseHolder_styled_templateObject2(), ui/* device.mobileS */.Uh.mobileS, ui/* device.tablet */.Uh.tablet);
var LicenseDesc = (0,styled_components_browser_esm["default"])(LicenseHolder_styled_Flex).withConfig({
    componentId: "sc-4587003c-3"
})(LicenseHolder_styled_templateObject3(), ui/* device.mobileS */.Uh.mobileS, ui/* device.tablet */.Uh.tablet);

;// CONCATENATED MODULE: ./src/features/about/LicenseHolder/index.tsx






var LicenseHolder_Text = ui/* Common.Text */.Gn.Text;
var LicenseHolderData = function(param) {
    var name = param.name, position = param.position, count = param.count;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LicenseHolderBox, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenseCount, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenseHolder_Text, {
                    as: "p",
                    size: "36px",
                    family: "bold",
                    mb: "0",
                    children: count
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LicenseDesc, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenseHolder_Text, {
                        as: "h3",
                        family: "bold",
                        size: "30px",
                        color: ui/* color.highempahis */.$_.highempahis,
                        mb: "12px",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenseHolder_Text, {
                        as: "h5",
                        size: "26px",
                        children: position
                    })
                ]
            })
        ]
    });
};
var LicenseHolder_Contact = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                align: "center",
                mb: "80px",
                children: "Pemegang Lisensi"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenseHolderContainer, {
                children: licenseHolder.map(function(data, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenseHolderData, (0,_object_spread/* default */.Z)({}, data), data.name + index);
                })
            })
        ]
    });
};
/* harmony default export */ var LicenseHolder = (LicenseHolder_Contact);

;// CONCATENATED MODULE: ./src/features/about/index.tsx











var about_Flex = ui/* Common.Flex */.Gn.Flex;
var GuestAbout = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomePageLayout["default"], {
        hideStartInvesting: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "About Us | Stockbit - Komunitas Saham Indonesia"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(about, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(vision, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(management, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                align: "center",
                                mb: "60px",
                                children: "Susunan organisasi"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(about_Flex, {
                                align: "center",
                                justify: "center",
                                margin: "0 0 160px 0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/images/organizationNew2.svg"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenseHolder, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contact, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var features_about = (GuestAbout);


/***/ })

}]);